import Image from 'next/image';
import React, { useContext } from 'react';

import CtaForm from '@components/common/CtaForm';
import Heading from '@components/Heading';
import Section from '@components/Section';
import { ProductPageContext } from '@contexts/PageContext';
import useGa from '@hooks/useGa';
import { loaderProp } from '@utils/random';

const HeroSection = () => {
  const pageData = useContext(ProductPageContext);
  const { ledeIcon, ledeText, heading, subHeading, heroImage } = pageData;

  return (
    <Section>
      <div className="flex flex-col justify-between lg:flex-row pt-0 lg:pt-12 w-full relative">
        <div className="max-w-screen-sm">
          <p
            className={`flex items-center gap-2 lg:mt-4 mb-4
              ${`motion-safe:opacity-0 motion-safe:animate-fadeInFromTop motion-safe:animation-delay-200`}`}
          >
            <Image
              alt={ledeIcon.description}
              src={ledeIcon.file.url}
              height="28"
              width="28"
              loader={loaderProp}
              loading="eager"
            />
            <span className="font-inter font-semibold text-black">
              {ledeText}
            </span>
          </p>
          <Heading
            Tag="h1"
            size="lg"
            className={`sm:text-5xl lg:text-6xl
              ${ledeText === 'Schedules' && 'lg:max-w-[32rem]'}
              ${ledeText === 'Shared queries' && 'lg:max-w-[28rem]'}
              ${`motion-safe:opacity-0 motion-safe:animate-fadeInFromTop motion-safe:animation-delay-200`}
            `}
          >
            {heading}
          </Heading>
          <p
            className={`sm:text-xl tracking-tight text-gray-600 mt-4 font-inter font-medium mb-6 md:mb-12 max-w-[500px]
              ${`motion-safe:opacity-0 motion-safe:animate-fadeInFromTop motion-safe:animation-delay-300`}`}
          >
            {subHeading}
          </p>

          <CtaForm onClickFn={useGa('Signup', 'Hero Features')} />
        </div>
        <div
          className={`w-full max-w-xl
          ${`motion-safe:opacity-0 motion-safe:animate-fadeInFromTop motion-safe:animation-delay-200`}
          ${
            ledeText !== 'Shared queries' &&
            ledeText !== 'Version history' &&
            ledeText !== 'Charts' &&
            ledeText !== 'Connections' &&
            ' lg:max-w-[29rem]'
          }
          ${
            (ledeText === 'Charts' || ledeText === 'SQL editor') &&
            ' lg:max-w-[32rem]'
          }
          ${ledeText === 'Shared queries' && ' lg:max-w-[36rem]'}
          ${ledeText === 'Version history' && ' lg:max-w-[32rem]'}
           mt-10 sm:mt-16 lg:mt-0`}
        >
          <Image
            priority
            alt={heroImage.description}
            src={heroImage.file.url}
            height={heroImage.file.details.image.height}
            width={heroImage.file.details.image.width}
            loader={loaderProp}
          />
        </div>

        <div className="absolute lg:-right-[100px] bottom-[-30px] lg:-top-[50px] -z-10">
          <Image
            alt="hero background image"
            src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/product/product_header_bg.svg`}
            height="510"
            width="716"
          />
        </div>
      </div>
    </Section>
  );
};

export default HeroSection;
